import { ProfileRoutineActionTypes } from "models/actionTypes/profileRoutineActionTypes";
import { ReduxConstants } from "utils/constants";

export const profileRoutineApproved = (id: number): ProfileRoutineActionTypes => {
  return {
    type: ReduxConstants.ProfileRoutineActions.PROFILE_ROUTINE_APPROVED,
    payload: id,
  };
};

export const profileRoutineSnoozed = (id: number): ProfileRoutineActionTypes => {
  return {
    type: ReduxConstants.ProfileRoutineActions.PROFILE_ROUTINE_SNOOZED,
    payload: id,
  };
};
